import React from 'react';
import { Layout } from '../../components/Layout';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { Globe, Facebook, Search, Phone, Mail, Users } from 'lucide-react';

export const LeadSources = () => {
  const sources = [
    { name: 'Google Ads', icon: Search, leads: 5, cost: 750, conversions: 1, color: 'text-blue-600 bg-blue-50' },
    { name: 'Facebook Ads', icon: Facebook, leads: 3, cost: 450, conversions: 0, color: 'text-purple-600 bg-purple-50' },
    { name: 'Direct Website', icon: Globe, leads: 2, cost: 0, conversions: 0, color: 'text-green-600 bg-green-50' },
    { name: 'Phone Calls', icon: Phone, leads: 2, cost: 0, conversions: 0, color: 'text-orange-600 bg-orange-50' },
    { name: 'Email Marketing', icon: Mail, leads: 0, cost: 200, conversions: 0, color: 'text-yellow-600 bg-yellow-50' },
    { name: 'Referrals', icon: Users, leads: 2, cost: 0, conversions: 0, color: 'text-pink-600 bg-pink-50' }
  ];

  const formatCurrency = (value) => new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 0 }).format(value);
  const totalLeads = sources.reduce((sum, s) => sum + s.leads, 0);

  return (
    <Layout>
      <div className="p-6 space-y-6">
        <div>
          <h1 className="text-3xl font-bold text-gray-900 dark:text-white">Lead Sources</h1>
          <p className="text-gray-600 dark:text-gray-400">Track lead attribution and source performance</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {sources.map((source) => {
            const Icon = source.icon;
            const cpl = source.leads > 0 ? source.cost / source.leads : 0;
            const conversionRate = source.leads > 0 ? (source.conversions / source.leads * 100).toFixed(0) : 0;
            const percentage = totalLeads > 0 ? ((source.leads / totalLeads) * 100).toFixed(0) : 0;

            return (
              <Card key={source.name}>
                <CardHeader>
                  <div className="flex items-center gap-3">
                    <div className={`p-3 rounded-lg ${source.color}`}>
                      <Icon className="h-6 w-6" />
                    </div>
                    <CardTitle className="text-lg">{source.name}</CardTitle>
                  </div>
                </CardHeader>
                <CardContent>
                  <div className="space-y-3">
                    <div className="flex items-center justify-between">
                      <span className="text-sm text-gray-600">Leads</span>
                      <span className="text-2xl font-bold">{source.leads}</span>
                    </div>
                    <div className="flex items-center justify-between text-sm">
                      <span className="text-gray-600">Cost Per Lead</span>
                      <span className="font-semibold">{formatCurrency(cpl)}</span>
                    </div>
                    <div className="flex items-center justify-between text-sm">
                      <span className="text-gray-600">Total Cost</span>
                      <span className="font-semibold">{formatCurrency(source.cost)}</span>
                    </div>
                    <div className="flex items-center justify-between text-sm">
                      <span className="text-gray-600">Conversions</span>
                      <span className="font-semibold">{source.conversions} ({conversionRate}%)</span>
                    </div>
                    <div className="pt-2 border-t">
                      <div className="flex items-center justify-between text-xs text-gray-500 mb-1">
                        <span>Share of Leads</span>
                        <span>{percentage}%</span>
                      </div>
                      <div className="w-full bg-gray-200 rounded-full h-2">
                        <div className="bg-blue-600 h-2 rounded-full" style={{ width: `${percentage}%` }}></div>
                      </div>
                    </div>
                  </div>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </Layout>
  );
};